<template>
  <div>
    <b-modal :id="`bv-modal-view-contact-`+page" hide-footer hide-header>
      <template #modal-title></template>
      
      <div class="p-3">

        <div v-if="showDelete" class="text-center">

          <div class="text-center pb-3">Are you sure you want to delete this contact?</div>

          <div class="px-3 py-2 bg-white rounded">
          <div>{{contact.email}}</div>
          </div>

                <div class="row pt-4">
                <div class="col">
                    <button type="button" class="btn btn-success col" @click="cancelDelete">Cancel</button>
                </div>
                <div class="col">
                          <div>
            <button v-if="deleting" type="button" class="btn btn-danger col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
                    <button v-else type="button" class="btn btn-danger col" @click="deleteAction">Delete contact</button>
              </div>
                </div>
              </div>

        </div>

        <div v-else>

          <div class="row">
          <div class="col">
              <label class="form-label">Business</label>
              <div class="col px-0">{{contact.business}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col">
              <label class="form-label">Email</label>
              <div class="col px-0">{{contact.email}}</div>
          </div>
          <div class="col">
              <label class="form-label">Status</label>
              <div class="col px-0">{{contact.status}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col">
              <label class="form-label">Category</label>
              <div class="col px-0">{{contact.category}}</div>
          </div>
          <div class="col">
              <label class="form-label">Location</label>
              <div class="col px-0">{{contact.location}}</div>
          </div>
        </div>
      
      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Notes</label>
            <div v-if="contact.notes"
              v-html="contact.notes"
              v-linkified
              style="white-space: pre-wrap" />
              <div v-else>---</div>
        </div>
      </div>

      <div class="mt-3">
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-danger col" @click="hideModal">Close</button>  
        </div>
      </div>
      </div>

          <div class="text-right pt-3"><a href="#/" @click="enableDelete" class="debit">Delete contact</a></div>

      </div>

      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['contact','page'],

  data() {
    return {
      showDelete: false,
      deleting: false,
    };
  },

  methods: {

        deleteAction() {
         
            this.deleting = true;

            axios.post(`/contacts/delete`, {contact: this.contact})
            .then((response) => {

            if (response.data.success) {
                this.hideModal();
                EventBus.$emit('get-contacts');
            } else {
                this.sweetfire(response.data.message);
            }

            this.deleting = false;

            });

      },

    cancelDelete() {
      this.showDelete = false;
    },

    enableDelete() {
      this.showDelete = true;
    },

    hideModal() {
      this.$bvModal.hide('bv-modal-view-contact-'+this.page);
    },

  },
};
</script>

<style scoped>
a.debit { color: #e55171 !important; }
input.form-control { text-align: center; }
</style>